(function () {
    'use strict';
    angular.module('logout', ["ngStorage", , "ngCookies"]).controller('logoutController', logoutController);
    logoutController.$inject = ["$location", "$http", "$sessionStorage", "$timeout", "userService"];
    function logoutController($location, $http, $sessionStorage, $timeout, userService) {
        var logout = this;
        logout.attemptLogout = attemptLogout;
        logout.memberIsLoggedOn = memberIsLoggedOn;
        logout.getLoggedInUser = getLoggedInUser;
        logout.navigateToChangePassword = navigateToChangePassword;
        logout.remindChangePasswordLater = remindChangePasswordLater;
        logout.closeModalPasswordCompliancy= closeModalPasswordCompliancy;
        logout.isShowModalSessionExpired = false;
        logout.isShowModalPasswordCompliancy = $sessionStorage.isPasswordNotCompliant;

        function loadData() {
            getSessionIdFromUrl();
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            if (!sessionId) {
                return;
            }
            userService.getSession(sessionId).then(function (result) {
                if (result) {
                    logout.expiries = new Date(result.data.expiries).getTime();
                    updateCountdown();
                } else {
                    angular.element(document.getElementById('modalLoggedInFromAnotherDevice')).addClass('show');
                }
            });
        }
        loadData();

        function getLoggedInUser() {
            if ($sessionStorage.PolicyHolder && $sessionStorage.PolicyHolder.hasOwnProperty('Forename')) {
                return 'Hello ' + $sessionStorage.PolicyHolder.Forename;
            }
        }

        function memberIsLoggedOn() {
            return userService.memberIsLoggedOn();
        }

        function getSessionIdFromUrl() {
            const params = new URLSearchParams(window.location.search);
            const sessionId = params.get('sid');
            if (sessionId) {
                sessionStorage.setItem("ngStorage-sessionId", JSON.stringify(sessionId));
            }
        }

        function attemptLogout() {
            sessionStorage.clear();
            var params = new URLSearchParams(window.location.search);
            var isGJW = window.location.host.includes('gjw') || params.get('brand')?.includes('gjw');

            //check if on GJW domain
            if (isGJW) {
                window.location = 'https://gjwdirect.com';
            } else {
                window.location = $location.protocol() + '://' + $location.host() + ($location.port() ? ':' + $location.port() : '') + '/login';
            }
        }

        function updateCountdown() {
            var now = new Date().getTime();
            var diff = logout.expiries - now;

            if (diff <= 0) {
                logout.isShowModalSessionExpired = true;
                return;
            }
            $timeout(updateCountdown, 1000);
        }

        function navigateToChangePassword() {
            $sessionStorage.isPasswordNotCompliant = false;
            window.location = $location.protocol() + '://' + $location.host() + ($location.port() ? ':' + $location.port() : '') + '/my-profile/change-password';
        }

        function remindChangePasswordLater() {
            closeModalPasswordCompliancy();
            $sessionStorage.isPasswordNotCompliant = false;
        }

        function closeModalPasswordCompliancy() {
            logout.isShowModalPasswordCompliancy = false;
        }
    }
})()